import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { Observable } from 'rxjs';

interface getMemberAddDialogFormObjectProps {
  formObject: DynamicForm;
  action: () => void;
  toggleVisibility?: () => void;
  isAddDisabled: Observable<boolean>;
  isConsellierMode?: boolean;
}

export const getMemberAddDialogFormObject = ({
  formObject,
  action,
  toggleVisibility,
  isAddDisabled,
  isConsellierMode,
}: getMemberAddDialogFormObjectProps): DialogObject => {
  return {
    title: isConsellierMode ? 'settings.consellier.add.title' : 'settings.members.add.title',
    description: '',
    actions: [
      {
        label: isConsellierMode ? 'settings.consellier.add.add' : 'settings.members.add.add',
        variant: 'success',
        onClick: () => action(),
        disabled: isAddDisabled,
      },
      {
        label: isConsellierMode ? 'settings.consellier.add.cancel' : 'settings.members.add.cancel',
        onClick: () => toggleVisibility?.(),
        variant: 'secondary',
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
  };
};
